import { CommunityService } from 'modules/community';
import { UiService } from 'modules/ui';

class ConfigurationService {
  async onFilesChange(tsv, rejected) {
    const fileIndex = 0;

    if (tsv.length) {
      await CommunityService.importCommentsFile(tsv[fileIndex]);

      UiService.setAlertSuccess('upload_tsv_success_message');
    } else {
      rejected = rejected[fileIndex];
      const format = '.tsv';
      const firstIndexRejected = rejected.name.length - format.length;
      const isRejected =
        rejected.name.indexOf(format, firstIndexRejected) !== -1;

      const errorMessage = isRejected ? 'invalid_file' : 'empty_tsv';

      UiService.setAlertError(errorMessage);
    }
  }

  async onExportFile() {
    try {
      const data = await CommunityService.exportCommentsFile();

      window.location.href = window.URL.createObjectURL(data);
      // eslint-disable-next-line no-empty
    } catch {}
  }
}

export default new ConfigurationService();
